import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Col } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import NumberOfBlogsCardBody from './NumberOfBlogsCardBody';
// import _axios from "axios";
import { ServerPath } from "../../../../Constant";
import { _axios } from '../../../../utils/axios';

const NumberOfVolunteers = () => {
    const [count, setCount] = useState("--");

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/users/volunteers-count`);
                if (response.data.success) {
                    setCount(response.data.data.total.toLocaleString());
                }
            } catch (error) {
                console.error("Error fetching volunteer count:", error);
            }
        };
        
        fetchCount();
    }, []);

    return (
        <Col md="6" lg="4" className="box-col-4">
            <Card className="sell-card">
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>No. of Volunteers
                                <i className="fa fa-circle"></i>
                            </P>
                            <H4>{count}</H4>
                        </div>
                    </div>
                </CardHeader>
                <NumberOfBlogsCardBody />
            </Card>
        </Col>
    );
};

export default NumberOfVolunteers;